import React, { useState } from 'react';
import { education } from '../../data/portfolioData';

const EducationSection = () => {
  const [openId, setOpenId] = useState(1);

  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section className="education-section" id="education">
      <div className="section-header">
        <span className="section-meta">Education</span>
        <h2 className="section-title">Education</h2>
      </div>
      <div className="accordion">
        {education.map(edu => (
          <div key={edu.id} className={`accordion-item ${openId === edu.id ? 'open' : ''}`}>
            <div className="accordion-header" onClick={() => toggle(edu.id)}>
              <div>
                <h4>{edu.degree}</h4>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
                <span className="accordion-year">{edu.year}</span>
                <i className={`fas fa-chevron-down accordion-icon`}></i>
              </div>
            </div>
            <div className="accordion-body">
              <p className="accordion-institution"><i className="fas fa-university" style={{marginRight:8}}></i>{edu.institution}</p>
              {edu.description.map((para, i) => <p key={i}>{para}</p>)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EducationSection;
